import { createSelector } from 'reselect';

export const getNotifications = (state) => state.notification.notifications;
export const getErrorTypes = (state) => state.notification.errorTypes;

export const getTopNotifications = createSelector(
  getNotifications,
  (notifications) => notifications.slice(0, 3)
);



// WEBPACK FOOTER //
// ./src/actions/notification/selectors.js